import CtaButtonGroup from "@/components/molecules/CtaButtonGroup";
import { CtaBannerV2Props } from "@/shared/data/home.v2.data";
import Text from "./shared/Text";

/**
 * CtaBannerV2 — "Ready to Build Your Creator Business?"
 *
 * Full-bleed section with a background image (creator at laptop),
 * gradient overlay for legibility, left-aligned two-tone headline
 * and dual CTAs.
 */

const CtaBannerV2 = ({
  titleMuted,
  titleBright,
  description,
  ctas,
  backgroundImage,
  backgroundImageMobile,
}: CtaBannerV2Props) => {
  return (
    <section className="relative w-full bg-black">
      {/* Background image — desktop */}
      <div
        className="absolute inset-0 hidden bg-cover bg-center md:block"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
        }}
        aria-hidden="true"
      />
      {/* Background image — mobile (falls back to desktop if no mobile variant) */}
      <div
        className="absolute inset-0 bg-cover bg-center md:hidden"
        style={{
          backgroundImage: `url('${backgroundImageMobile ?? backgroundImage}')`,
        }}
        aria-hidden="true"
      />
      {/* Dark-to-transparent overlay for copy legibility */}
      <div
        className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-transparent md:from-black/70 md:via-black/25 md:to-transparent"
        aria-hidden="true"
      />

      <div className="container relative mx-auto px-4 py-12 sm:px-6 md:px-8 md:py-28 lg:px-12 lg:py-36">
        <div className="mx-auto max-w-6xl">
        <div className="max-w-2xl">
          <Text
            as="h2"
            variant="display-lg"
            className="text-[32px] md:text-[40px] lg:text-[48px]"
          >
            <span className="text-white">{titleMuted}</span>
            <br />
            <span className="text-white">{titleBright}</span>
          </Text>
          {description ? (
            <Text
              as="p"
              variant="body-lg"
              className="mt-5 max-w-xl text-darkSlate03"
            >
              {description}
            </Text>
          ) : null}
          {ctas && ctas.length ? (
            <div className="mt-8">
              <CtaButtonGroup
                ctas={ctas}
                gap="flex gap-3"
                fullWidthOnMobile={false}
              />
            </div>
          ) : null}
        </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBannerV2;
